
export type ApiV1DashboardStatisticsGet200ResponseStatistics = {
  activeUsers?: number;
  period?: string;
  totalRevenue?: number;
  totalSubscriptions?: number;
};
